<template>
  <footer dir="rtl" class="bg-[#0f1417] text-white pt-12">
    <!-- CTA Bar -->
   

    <!-- Main -->
    <div class="max-w-7xl mx-auto px-6 mt-10 grid grid-cols-1 md:grid-cols-12 gap-8">
      <!-- Brand -->
      <div class="md:col-span-5 lg:col-span-4 space-y-4">
        <div class="text-2xl font-extrabold"> سامانه آنلاین طلا و سکه سالاری</div>
        <p class="text-sm text-white/75 leading-7">
          پلتفرم تخصصی خرید و فروش  سکه و ابشده ؛ش؛ با تکیه بر شفافیت قیمت، کارمزد منصفانه و پشتوانه بانکی.
          تجربه‌ای ساده، امن و سریع برای سرمایه‌گذاری شما.
        </p>

        <!-- Social -->
        <div class="flex flex-wrap items-center gap-2 pt-1">
          <a href="#" class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#1e2623] ring-1 ring-[#334D44]/60 hover:bg-[#22302b] transition" aria-label="Instagram">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
          </a>
          <a href="#" class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#1e2623] ring-1 ring-[#334D44]/60 hover:bg-[#22302b] transition" aria-label="X">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M18.3 2H21l-6.5 7.43L22 22h-6.8l-4.44-5.78L5.6 22H3l7.1-8.12L2 2h6.9l4 5.33L18.3 2Zm-1.2 18h1.9L7.1 4H5.2Z"/></svg>
          </a>
          <a href="#" class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#1e2623] ring-1 ring-[#334D44]/60 hover:bg-[#22302b] transition" aria-label="Telegram">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M9.03 15.45 8.9 18.6a1 1 0 0 0 1.58.84l2.28-1.65 3.8 2.8a1 1 0 0 0 1.57-.62L20.97 4.6a1 1 0 0 0-1.34-1.12L3.33 9.77a1 1 0 0 0 .06 1.87l4.86 1.83 8.55-7.53-7.77 9.51Z"/></svg>
          </a>
        </div>

      </div>

      <!-- Columns -->
      <div class="md:col-span-7 lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-8">
        <!-- Links -->
        <div>
         
        </div>

       
        <div>
         
        </div>

        <!-- Contact -->
        <div>
          <h6 class="font-extrabold mb-4">تماس با ما</h6>
          <ul class="space-y-3 text-sm text-white/85">
            <li class="flex items-start gap-2"><span class="mt-0.5 inline-block h-2 w-2 rounded-full bg-emerald-400"></span>کرمان بازار زرگرها قیصریه ابراهیم خان</li>
            <li>۰۹۱۳۲۴۲۱۵۶۱</li>
           
          </ul>
        </div>

    
      </div>
    </div>

    <!-- Bottom -->
    <div class="mt-10 border-t border-[#334D44]/40">
      <div class="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center gap-4 justify-between">
       
        <div class="text-xs text-white/60">© 1404 سکه و ابشده ؛ش؛ — تمامی حقوق محفوظ است.</div>
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
